module.exports = __webpack_public_path__ + "img/audio.113ffeae.svg";